import { INTEGRATION_TYPE } from "../utils/enums";

export function depotIntegrationModel(data) {
    const item = data || {};
    return {
        sourceId: item.sourceId || "",
        integrationType: item.integrationType || INTEGRATION_TYPE.none,
        skipDriverTip: item.skipDriverTip || false,
        useRegistrationDate: item.useRegistrationDate || false,
        disableDelete: item.disableDelete || false,
        enabled: item.enabled || false,
        skipCodeWords: item.skipCodeWords || [],
        mandatoryPOD: item.mandatoryPOD || false,
    };
}

export function depotIntegrationServerModel(data) {
    const item = data || {};
    return {
        SourceId: item.sourceId || "",
        SkipDriverTip: item.skipDriverTip || false,
        UseRegistrationDate: item.useRegistrationDate || false,
        DisableDelete: item.disableDelete || false,
        Enabled: item.enabled || false,
        SkipCodeWords: item.skipCodeWords || [],
        MandatoryPOD: item.mandatoryPOD || false,
    };
}